import { bootVueApp } from '@web/bootstrap.js';
import Microsite from '@web/components/page/microsite/Microsite.vue';
import { createApp } from 'vue';
import { AppContext } from '@web/enums/AppContext';
import { useAppContextStore } from '@web/stores/appContext';

const app = createApp(Microsite);

bootVueApp(app);

useAppContextStore().setEntry(AppContext.MICROSITE);

app.mount('#app');
